
import ParseCall from './ParseCall.js'
import ParseIO from './ParseIO.js'
import ParseSentenceAssign from './ParseSentenceAssign.js'
import ParseSentenceFor from './ParseSentenceFor.js'
import ParseSentenceIf from './ParseSentenceIf.js'
import ParseSentenceRepeat from './ParseSentenceRepeat.js'
import ParseSentenceSelect from './ParseSentenceSelect.js'
import ParseSentenceWhile from './ParseSentenceWhile.js'

function ParseSentences (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.hintHelper = parser.hintHelper
    this.SC = parser.config
    this.parseSentenceFor = new ParseSentenceFor(this.parser)
    this.parseIO = new ParseIO(this.parser)
    this.parseIO = new ParseIO(this.parser)
    this.parseCall = new ParseCall(this.parser)
    this.parseSentenceAssign = new ParseSentenceAssign(this.parser)
    this.parseSentenceIf = new ParseSentenceIf(this.parser)
    this.parseSentenceWhile = new ParseSentenceWhile(this.parser)
    this.parseSentenceRepeat = new ParseSentenceRepeat(this.parser)
    this.parseIO = new ParseIO(this.parser)
    this.parseSentenceSelect = new ParseSentenceSelect(this.parser)
    this.parseIO = new ParseIO(this.parser)
}

ParseSentences.prototype = {
    parse () {
        let nextTokens = [this.SC.K_WRITE, this.SC.K_READ, this.SC.K_FOR, this.SC.K_IF, this.SC.K_WHILE, this.SC.K_REPEAT, this.SC.K_WAIT, this.SC.K_SELECT, this.SC.K_CLEAR_SCREEN]
        if (this.hintHelper) {
            this.hintHelper.checkTokensForHints(nextTokens)
        }
        while (this.scanner.nextIsIn(nextTokens) || this.scanner.nextIsIn([this.SC.IDENT])) {
            this.parserSentence()
            if (this.hintHelper) {
                this.hintHelper.checkTokensForHints(nextTokens)
            }
        }
    },
    parserSentence () {
        if (this.scanner.nextIs(this.SC.K_FOR)) {
            this.parseSentenceFor.parse()
        } else if (this.scanner.nextIs(this.SC.K_WRITE)) {
            this.parseIO.parseWrite()
        } else if (this.scanner.nextIs(this.SC.K_READ)) {
            this.parseIO.parseRead()
        } else if (this.scanner.nextIs(this.SC.IDENT)) {
            if (this.parser.stable.hasMethod(this.scanner.next().lexema)) {
                this.parseCall.callableCall(false)
            } else {
                this.parseSentenceAssign.parse()
            }
        } else if (this.scanner.nextIs(this.SC.K_IF)) {
            this.parseSentenceIf.parse()
        } else if (this.scanner.nextIs(this.SC.K_WHILE)) {
            this.parseSentenceWhile.parse()
        } else if (this.scanner.nextIs(this.SC.K_REPEAT)) {
            this.parseSentenceRepeat.parse()
        } else if (this.scanner.nextIs(this.SC.K_WAIT)) {
            this.parseIO.parseWait()
        } else if (this.scanner.nextIs(this.SC.K_SELECT)) {
            this.parseSentenceSelect.parse()
        } else if (this.scanner.nextIs(this.SC.K_CLEAR_SCREEN)) {
            this.parseIO.parseClearScreen()
        }
    }
}

export default ParseSentences



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentences.js